import React from 'react';
import PropTypes from 'prop-types';

import '../../TermsAndConditions/TermsAndConditions.scss';

export default function TermsAndConditionsLMA(props) {
  const { brand: { primaryColor } = {} } = props;

  return (
    <div className="c-terms-and-conditions">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <h1>Terms and Conditions</h1>

            <ol>
              <li>
                <strong>Applications</strong>
                <br />
                <br />
                To apply for a place on the Course (as defined below) either
                complete the relevant application form (“Application Form”) or
                apply online. Your application is an offer to Lloyd’s Maritime
                Academy (a trading division of Informa Connect Limited) (“LMA”)
                to study on the course as set out in the Application Form (“the
                Course”) which is subject to LMA’s acceptance. A binding
                contract between LMA and you will only be formed when written
                confirmation of acceptance (which may be sent by email) is sent
                by LMA to you.
              </li>
              <li>
                <strong>
                  Partner Institution Applications and Application Fees
                </strong>
                <br />
                <br />
                Where the Course is provided by LMA in partnership with a third
                party educational institution (a “Partner Institution”) there
                may be a fee for processing your application along with
                additional requirements for acceptance on to the Course, as set
                out in the registration process. Where a Course has an
                application fee included as part of the Course fee participants
                will need to pay this when they make their application.
                Applications will not be processed if the application fee has
                not been received. Anyone who is rejected by a Partner
                Institution on academic grounds will have their application fee
                refunded in full. Where students have incomplete applications,
                withdraw their application or fail to respond to requests for
                further information or do not take up their place after being
                awarded a place or offered a place, the application fee will be
                treated as a cancellation fee and will not be refunded.
              </li>
              <li>
                <strong>Payment</strong>
                <br />
                <br />
                You must pay to LMA the fees set out in the Application Form.
                Payment of any invoice must be received by LMA, in full and in
                cleared funds, by the due date set out on the invoice or seven
                days before the start date of the Course, whichever is sooner.
                Please note that non-payment of fees will result in the
                withholding of any Course materials due to be provided as part
                of the Course (“the Course Materials”) and LMA may charge you
                interest on any overdue fees at the rate of 2% per annum above
                National Westminster Bank Plc’s base lending rate from time to
                time. You may pay by (i) Visa, MasterCard, Diners Club or
                American Express; or (ii) bank transfer. On booking, your credit
                card details will be required. No charge will be taken at this
                point, but if you fail to pay any invoice in full and on time,
                we will charge the card for any outstanding sums.
              </li>
              <li>
                <strong>Taxes</strong>
                <br />
                <br />
                It is the intent of the parties that LMA will receive payment of
                your fees net of all applicable taxes, including without
                limitation, sales, VAT, service or withholding taxes (“
                <strong>Taxes</strong>”), all of which shall be paid solely by
                you. If and to the extent that any Taxes are levied upon, or
                found to be applicable to, the whole or any portion of the
                payment of your fees, the amount of such payment shall be
                increased by an amount necessary to compensate for the Taxes
                (including any amount necessary to “gross up” for Taxes levied
                on the increase itself).
              </li>
              <li>
                <strong>Participant Cancellation Policy</strong>
                <br />
                <br />
                You may cancel your place on the Course by giving notice in
                writing to the Course Administrator up to (and including) 7 days
                from the date LMA confirms your acceptance to the Course in
                accordance with Condition 1 and you will not be liable for the
                payment of any fees and any fees already paid to LMA for the
                Course will be refunded. If LMA receives your notice of
                cancellation 8 days or more from the date LMA has confirmed your
                acceptance to the Course you will still receive a refund of your
                fees already paid to LMA, subject to payment by you to LMA of:
                (i) if applicable, a cancellation fee equal to the application
                fee in accordance with Clause 2; or (ii) where (i) is not
                applicable, a cancellation fee of £200 to cover administrative
                costs (which shall be payable immediately upon your
                cancellation), in each case, provided such notice of
                cancellation is received by LMA before the first day of the
                Course. For the avoidance of doubt, the "first day of the
                Course" shall mean Day 1 of the first iteration or scheduled
                delivery of the Course or Day 1 of when the on-demand access to
                the Course starts. LMA regrets that no refunds can be given for
                any cancellation notice it receives on or after the first day of
                the Course and, in such circumstances, the full fees remain
                payable by you to LMA.
              </li>

              <li>
                <strong>Course Cancellation and Re-scheduling by LMA</strong>
                <br />
                <br />
                LMA reserves the right to cancel or change the dates of the
                Course. LMA may offer you the option of participating in any
                re-arranged comparable Course that LMA chooses (in its sole
                discretion) to organise. If you choose not to participate in any
                re- arranged Course or if LMA does not organise such a Course
                then you will (as your sole remedy) be entitled to receive
                either a credit note or a refund in respect of the fees received
                from you by LMA. LMA reserves the right to make non-material
                alterations and/or amendments to the Course as in its reasonable
                opinion it considers to be in the best interest of the Course
                (including, without limitation, any non-material alteration to
                the Course or the scope of the Course) without liability.
              </li>

              <li>
                <strong>Course Platform</strong>
                <br />
                <br />
                With respect to your participation on a Course: (a) you
                undertake to be responsible for any technical requirements
                needed to enable you to access the Course website, app or other
                platform (the “<strong>Course Platform</strong>”) made available
                by LMA to facilitate participation in the Course. We do not
                guarantee that the Course Platform will operate continuously,
                securely or without errors or interruption, and we do not accept
                any liability for its temporary unavailability. We do not
                guarantee that the Course Platform and/or any content thereon
                (including, without limitation, any content available for
                download) will be free from viruses, infections, Trojan horses,
                worms and/or any other code that has contaminating or
                destructive properties. You must not attempt to interfere with
                the proper working of the Course Platform (for example, by
                attempting to circumvent security or tamper with, hack into or
                otherwise disrupt any computer system, server, website, router
                or any other internet connected device). You agree to comply
                with any website terms of use and/or fair or acceptable use
                policies indicated on any website on which the Course Platform
                is hosted, (b) we do not endorse or accept any responsibility
                for the content, or the use of, any goods or services that may
                be identified or described on the Course Platform and we shall
                not be liable for any loss or damage caused or alleged to be
                caused by or in connection with use of, or reliance on, any
                content, goods or services available on or through the Course
                Platform or any website or other resource referenced therein,
                (c) LMA may issue you with a username and password. Usernames
                and passwords are confidential and remain the property of LMA at
                all times and may not be sold, assigned or transferred to any
                third party without our permission. Your username and password
                are personal to you. You hereby agree that you will not permit
                others to use your username or password and you will be and
                remain liable for the acts of any person using your username and
                password, (d) any posts, messages or other materials,
                information or data you supply or upload to the Course Platform
                (collectively, “<strong>Materials</strong>”) will be considered
                non-confidential and non-proprietary, and we have the right to
                use, copy, distribute and disclose to third parties any such
                Materials for any purpose. You hereby waive any moral rights in
                any Materials to the extent permitted by applicable law. We
                reserve the right, at our sole discretion, to edit or remove
                postings to any message boards on the Course Platform and delete
                or use electronic methods to block or filter any Materials at
                our discretion, but we do not have any obligation to do so. You
                shall not make libellous postings or any postings that are
                illegal or infringe the intellectual property rights of any
                third party. LMA will not be responsible for monitoring
                Materials for compliance with law, (e) you may use the Course
                Platform solely for access to the Course. Without limitation,
                you must not (i) download, store, reproduce, transmit, display,
                copy, distribute, exploit or use the Course Platform and/or any
                content thereon for your own commercial gain, (ii) use the
                Course Platform and/or any content thereon in any manner other
                than in compliance with law and these terms and conditions,
                (iii) infringe our intellectual property rights or those of any
                third party in relation to your use of the Course Platform
                and/or any content thereon, (iv) transmit, or procure the
                sending of, any unsolicited or unauthorised advertising or
                promotional material or any other form of similar solicitation,
                and/or (iv) knowingly transmit, send or upload any data that
                contains viruses, infections, Trojan horses, worms and/or any
                other code that has contaminating or destructive properties, and
                (f) we are under no obligation to oversee, monitor or moderate
                any interactive service we provide on the Course Platform and,
                without limitation, we expressly exclude all liability for any
                loss, injury or damage whatsoever arising from the use of any
                interactive service by any user, whether the service is
                moderated or not.
              </li>

              <li>
                <strong>Intellectual Property</strong>
                <br />
                <br />
                LMA owns or is licensed all intellectual property rights in the
                Course and Course Materials. You acknowledge and agree that any
                Course Materials which are provided to you may only be used
                solely for your own private, non-commercial use. You may not
                reproduce, transmit, distribute, resell, sub-license, rent,
                lease, transfer or attempt to assign the rights in or
                commercially exploit or use the Course Materials, alter or
                create derivative works from the Course Materials or otherwise
                use or exploit the Course Materials other than as expressly
                permitted in this Condition 8.
              </li>

              <li>
                <strong>Entire Agreement</strong>
                <br />
                <br />
                You and LMA (“the Parties”) acknowledge that these terms and
                conditions, together with your application form, constitute the
                entire agreement between the Parties “Agreement”) in relation to
                the Course and that neither Party relies upon any oral or
                written representation made to it by the other Party. No
                variation of this Agreement shall be effective unless made in
                writing signed by or on behalf of each of the Parties to this
                Agreement.
              </li>

              <li>
                <strong>Governing Law and Jurisdiction</strong>
                <br />
                <br />
                This Agreement will be governed by the laws of the England and
                disputes under or in connection with them shall be subject to
                the non-exclusive jurisdiction of the English courts.
              </li>

              <li>
                <strong>Disclaimer and Limitation of Liability</strong>
                <br />
                <br />
                You expressly assume all risks associated with, resulting from
                or arising in connection with your participation in the Course.
                LMA does not make any warranty as to the Course in general,
                including, without limitation, the beneﬁt or outcome (commercial
                or otherwise) that you may achieve as a result of attending the
                Course. All indemnities, warranties, representations, terms and
                conditions (whether express or implied) except as set out herein
                and/or as may be otherwise expressly advised as part of the
                particular Course’s registration process are excluded.
                <br />
                <br />
                LMA’s liability for losses you suffer as a result of LMA
                breaching this Agreement or otherwise in connection with the
                Course is limited to those losses that are a foreseeable
                consequence of LMA breaching this Agreement. Losses are
                foreseeable where they could be contemplated by you and LMA at
                the time LMA accept you onto the Course. To the extent that LMA
                is liable for such losses, LMA’s total liability will only
                extend to the fees paid by you to LMA under the Agreement. In
                addition, LMA shall not be responsible for any indirect losses
                which happen as a side effect of the main loss or damage and
                which are not foreseeable by LMA. For the avoidance of doubt,
                nothing in this Condition 11 shall seek to limit or exclude
                LMA’s liability for: (i) death or personal injury resulting from
                negligence or (ii) fraud or fraudulent misrepresentation; (iii)
                any breach of LMA’s obligations implied by section 12 of the
                Sale of Goods Act 1979 or section 2 of the Supply of Services
                and Services Act 1982; (iv) any losses for which it is
                prohibited by section 7 of the Consumer Protection Act 1987 to
                limit liability; or (v) any other matter for which it would be
                illegal or unlawful for LMA to exclude or attempt to exclude its
                liability.
              </li>

              <li>
                <strong>Severance</strong>
                <br />
                <br />
                If any provision of this Agreement (or any part of any
                provision) is found by a court or other authority of competent
                jurisdiction to be invalid, illegal or unenforceable, that
                provision or part-provision shall, to the extent required, be
                deemed not to form part of this Agreement and the validity and
                enforceability of the other provisions of this Agreement shall
                not be affected.
              </li>

              <li>
                <strong>Waiver</strong>
                <br />
                <br />
                No failure by either Party in exercising any right, power or
                remedy shall operate as a waiver of the same.
              </li>

              <li>
                <strong>Force Majeure</strong>
                <br />
                <br />
                LMA shall not be deemed to be in breach of this Agreement or
                otherwise be liable to you as a result of any delay or failure
                to perform its obligations if and to the extent that such delay
                or failure is caused by a force majeure event (this means any
                event arising that is beyond the reasonable control of LMA,
                including but not limited to, any industrial dispute, health
                scares or epidemics, tutor, consultant or participant
                cancellation or withdrawal, venue damage or cancellation,
                governmental regulations or action, fire, flood, disaster, civil
                riot, acts of terrorism or war). If the period of delay or
                non-performance continues for 3 months, either party may
                terminate this Agreement by giving 14 days' written notice to
                the other party and any fees already paid to LMA for the Course
                will be refunded.
              </li>

              <li>
                <strong>Data Protection and Privacy</strong>
                <br />
                <br />
                The personal information that you provide to LMA will be held by
                us on a database and, where we have appropriate
                authorisation/justification (which may include, without
                limitation, express/implied consent or legitimate interests),
                may be shared with other entities within the Informa Group and
                selected third parties internationally for promotional and other
                purposes. Your personal information may also be shared with
                government entities and regulatory authorities as required by
                law. For more information about how we may use the personal
                information you provide to us, to update and/or correct such
                personal information, or how you can opt-out of future marketing
                communications please see our{' '}
                <a
                  href="https://www.informa.com/privacy-policy/"
                  style={{ color: primaryColor }}
                >
                  Privacy Notice.
                </a>
                <br />
                <br />
                <em>
                  Lloyd’s and the Lloyd’s Crest are the registered trademarks of
                  the Society incorporated by the Lloyd’s Act 1871 by the name
                  of “Lloyd’s”
                </em>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

TermsAndConditionsLMA.propTypes = {
  brand: PropTypes.shape({
    primaryColor: PropTypes.string,
  }),
};
